import { render, staticRenderFns } from "./SharedMediaFolderDelete.vue?vue&type=template&id=37dc8fde&"
import script from "./SharedMediaFolderDelete.vue?vue&type=script&lang=js&"
export * from "./SharedMediaFolderDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports